export default async function getParticipantAudioLevel(participantId) {
  try {
    if (!window.rtcpeers) {
      return;
    }
    // SFU Audio level
    if (window.rtcpeers.getCurrentType() === 'sfu') {
      const consumer = window.rtcpeers.sfu.consumers[participantId + '/cam-audio'];
      if (!(consumer && consumer.getStats)) {
        return;
      }
      return Array.from((await consumer.getStats()).values()).find((s) => 'audioLevel' in s)
        .audioLevel;
    }

    // P2P Audio level
    const consumer = window.rtcpeers.peerToPeer.rtcPeerConnections[participantId];

    //console.log(consumer);
    if (!(consumer && consumer.getStats)) {
      return;
    }
    return Array.from((await consumer.getStats()).values()).find(
      (s) => 'type' in s && s.type === 'inbound-rtp' && 'audioLevel' in s,
    ).audioLevel;
  } catch (e) {
    console.error(e);
  }
}
